import DataTile from "../../metrics/DataTile";
import { fetchCustomers} from "../../../../actions";
import React, {useEffect} from "react";
import {bbDangerousStringToDate} from "../../../../util/bbHelpers";
import {useDispatch, useSelector} from "react-redux";
import BBIconShieldBuilding from "../../../../assets/bbCustomIcons/BBIconShieldBuilding";


const Tile = (props) => {

    //customers from state-- customers returns as an object containing customer data objects as key/value pairs
    const { customers, loadingCustomers } = useSelector(({customer})=> customer);
    const dispatch = useDispatch();

    //api call to get customers from state
    useEffect(()=>{
        if(!customers && !loadingCustomers){
            dispatch(fetchCustomers())
        }
    }, [customers, dispatch])

    //create function that compares one date to another date and returns number of days different
    const calcDiffDays = (object, dateKey) => {
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

        const firstDate = bbDangerousStringToDate(object[dateKey], false)

        const secondDate = new Date();

        return Math.round(Math.abs((firstDate - secondDate) / oneDay));
    }

    const customerArray = customers && Object.values(customers)

    //newCustomer is the array created by converting customers object from state to an array and then filtering those objects to all those created
    //less than 7 days ago
    const newCustomers = customers
        && Array.isArray(customerArray)
        && customerArray
            .filter(customer=> calcDiffDays(customer, "CreatedDate") < 30);

    //valueFunction is part of Data Tile structure, this function tells the tile to either show the length of the newCustomers array
    // (how many customer objects created in the last 7 days) or to show null on the created data tile
    const valueFunction = () => {
        return customers && newCustomers ?
            newCustomers.length : null;
    }

    return (
        //find Data Tile component @/components/customBreachBits/metrics
        <DataTile
            color="electric-blue"
            subTitle="New Clients Last 30 Days"
            // tipText={"New Clients are clients added in the last 7 days."}
            icon={<BBIconShieldBuilding style={{fontSize: 70}}/>}
            valueFunction={valueFunction}
        />
    )
}

export default Tile;